import React, { MouseEvent } from 'react'

import { Secondary, Tertiary } from '@cinch/oxd-components/button/src'
import { Plus, Tick } from '@cinch/oxd-components/icons/src'

import { CompareVehicle } from '@cinch/oxd-redux/compare/src/interfaces'

export interface CompareToggleProps {
  isActive?: boolean
  onAddCompare: (vehicle: CompareVehicle) => void
  onRemoveCompare: (id: number) => void
  data: {
    id: number
    title: string
    subtitle: string
    price: string
  }
}

const CompareToggle: React.FC<CompareToggleProps> = ({ isActive, onRemoveCompare, onAddCompare, data, ...props }) => {
  const { id, title, subtitle, price } = data
  const CompareButton = isActive ? Secondary : Tertiary

  const onClick = (event: MouseEvent<HTMLElement>) => {
    event.stopPropagation()

    return isActive ? onRemoveCompare(id) : onAddCompare({ id, title, subtitle, price })
  }

  return (
    <CompareButton
      size={'mini'}
      icon={isActive ? Tick : Plus}
      oxdIcon={isActive ? Tick : Plus}
      type="button"
      data-testid="product-compare-btn"
      onClick={onClick}
      oxford={true}
      {...props}
    >
      Compare
    </CompareButton>
  )
}

export default CompareToggle
